

function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.indexOf(role) >= 0)
  } else {
    return true
  }
}

function filterAsyncRouter(asyncRouterMap, roles) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true
    }
    return false
  })
  return accessedRouters
}
const permission = {
  // state: {
  //   routers: constantRouterMap,
  //   addRouters: []
  // },
  // mutations: {
  //   SET_ROUTERS: (state, routers) => {
  //     state.addRouters = routers
  //     state.routers = constantRouterMap.concat(routers)
  //   }
  // },
  // actions: {
  //   GererateRoutes ({commit}, data) {
  //     return new Promise(resolve => {
  //        const {roles} = data
  //       if (roles.indexOf('admin') >= 0) {
  //         accessRouters = asyncRouterMap
  //       } else {
  //         accessRouters = filterAsyncRouter(asyncRouterMap, new Array(roles))
  //       }
  //       commit('SET_ROUTERS', accessRouters)
  //       resolve()
  //     })
  //   }
  // }
}

export default permission
